import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map, distinctUntilChanged } from 'rxjs/operators';
import {
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
  Router,
  RouterEvent
} from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../environments/environment';
import { AuthService } from './services/auth.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'companies';
  signature = environment.signature;

  constructor(
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private auth: AuthService,
    private toastr: ToastrService
  ) {
    this.isNavigationPending$.subscribe((showSpinner) => {
      showSpinner ? this.spinnerService.show() : this.spinnerService.hide();
    });
  }

ngOnInit(): void {
  const token = new URLSearchParams(window.location.search).get('token');

  if (token && !this.auth.isAuthenticated()) {
    this.auth.validateToken(token).subscribe(valid => {
      if (valid) {
        localStorage.setItem('token', token);
        this.router.navigateByUrl('/steps/route');
      } else {
        this.toastr.error('Invalid token');
      }
    });
  }
}

  isNavigationPending$: Observable<boolean> = this.router.events.pipe(
    filter((event: RouterEvent) => this.isConsideredEvent(event)),
    map((event: RouterEvent) => this.isNavigationStart(event)),
    distinctUntilChanged()
  );

  private isConsideredEvent(event: RouterEvent): boolean {
    return this.isNavigationStart(event) || this.isNavigationEnd(event);
  }

  private isNavigationStart(event: RouterEvent): boolean {
    return event instanceof NavigationStart;
  }

  private isNavigationEnd(event: RouterEvent): boolean {
    return (
      event instanceof NavigationEnd ||
      event instanceof NavigationCancel ||
      event instanceof NavigationError
    );
  }
}
